<template>
    <div class="vue timparty-rewards-special rewards bg-dark py-5" v-if="access_token && rewards">
        <div v-if="isEnabled">
            <LoaderOverlay v-if="loading"/>


            <div class="rewards">
                <div class="row">
                    <div class="col-lg-10 offset-lg-1  text-center">
                        <h1 class="text-white mb-4">{{ __('Più sei TIM e più crescono i tuoi vantaggi') }}</h1>
                        <div class="spaced-text text-orange mb-4">{{ __('PER I CLIENTI FISSO&MOBILE') }}</div>


                        <div class="text-white text-center">Essere un cliente FISSO&MOBILE ti offre tante opportunità con TIM Party!

                            <div class="col-sm-8 offset-sm-2 text-left py-5">
                                <ul>
                                    <li><span class="text-orange">GIOCA E VINCI</span>: ogni giorno moltiplichi le possibilità di vincere: avrai ben 5 tentativi giornalieri per tutti i concorsi TIM Party.</li>
                                    <li><span class="text-orange">PARTY DELLA DOMENICA</span>: ogni settimana hai 5 giocate per provare a vincere i premi in palio.</li>
                                    <li><span class="text-orange">VANTAGGI</span>: offerte esclusive sui migliori Brand.</li>
                                </ul>
                            </div>


                            Per diventare un cliente FISSO&MOBILE basta avere una linea fissa e una linea mobile, oppure avere attiva sulla mobile TIM UNICA, TIM 100%, TIM Smart, TIM Connect o TIM Super (per i dettagli consultare le <a href="https://www.timparty.tim.it/come-funziona" target="_blank" class="text-white">FAQ</a>).
                        </div>
                    </div>
                </div>
                <div class="rewards-special-slider mt-4" v-if="rewards">
                    <div class="slide-content px-2" v-for="reward in rewards" v-bind:key="reward.rewardId">
                        <rewards-card :reward="reward" v-if="reward.rewardId"></rewards-card>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';
import LoaderOverlay from './LoaderOverlay.vue'
import RewardsCard from './RewardsCard.vue'
import $ from 'jquery';
import 'slick-carousel';

export default {
    name: 'RewardsSliderSpecial',
    mixins: [TimPartyMixin],
    components: {LoaderOverlay, RewardsCard},
    props: {

        apiUrl: String,
    },
    data: function () {
        return {
            rewards: null,
        };
    },
    mounted: function () {
        this.setApiUrl(this.apiUrl);

        if(this.access_token)
            this.getRewards();

    },
    methods: {
        activateSlider: function () {
            this.$nextTick( function() {
                $('.rewards-special-slider').slick({
                    dots: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 5.1,
                    slidesToScroll: 4,
                    autoplay: false,
                    responsive: [

                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2.1,
                                slidesToScroll: 1,
                                dots: false,
                    //
                            }
                        },
                        {
                            breakpoint: 520,
                            settings: {
                                slidesToShow: 1.1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: false,
                            }
                        }
                    ]
                });
            });
        },

        getRewards: function(){

          var self = this;

          var payload = {
            action: 'getSpecialRewards',
            // action: 'getRewards',
            access_token: this.access_token,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;

            if(response.rewards != undefined){
                self.rewards = response.rewards;
                self.activateSlider();
            }

          } );

        },
        /*
        gotoCatalogClick: function(){

          this.aaEvent('click', {
                            form: {
                                click: 'Scopri vantaggi',
                                }
                            });

        },
        */

    },
    computed: {
        isEnabled: function(){
          return ( this.user.cluster && this.user.cluster != 'GUEST_STAR');
        },
    },
    watch: {
        access_token: function( new_val, old_val){
            this.getRewards();
        }
    }
}
</script>


